module.exports = "<div class=\"zero-filter-results\">\r\n    <h1 class=\"zero-filter-results-header\">There are no products matching your filters.</h1>\r\n    <div class=\"zero-filter-results-blurb\">\r\n        Please try a different combination or disable your filters above to see all{{ !!$ctrl.term ? ' ' + $ctrl.term + ' ' : ' ' }}products.\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/tiles/zero-filter-results.component.html
// module id = 283
// module chunks = 0 2